"use strict";
exports.__esModule = true;
exports.Events = exports.WebInteractionType = exports.WebComponentType = void 0;
var WebComponentType;
(function (WebComponentType) {
    WebComponentType["BUTTON"] = "BUTTON";
    WebComponentType["CARD_OR_SECTION"] = "CARD_OR_SECTION";
    WebComponentType["VIDEO"] = "VIDEO";
    WebComponentType["INPUT"] = "INPUT";
    WebComponentType["OPTION"] = "OPTION";
})(WebComponentType = exports.WebComponentType || (exports.WebComponentType = {}));
var WebInteractionType;
(function (WebInteractionType) {
    WebInteractionType["CLICK"] = "CLICK";
    WebInteractionType["EXPAND"] = "EXPAND";
    WebInteractionType["COLLAPSE"] = "COLLAPSE";
    WebInteractionType["SCROLL"] = "SCROLL";
    WebInteractionType["TYPING"] = "TYPING";
    WebInteractionType["SELECT"] = "SELECT";
})(WebInteractionType = exports.WebInteractionType || (exports.WebInteractionType = {}));
var Events;
(function (Events) {
    var WebScreenShown = (function () {
        function WebScreenShown(struct) {
            this.struct = struct;
            this.name = 'Web Screen Shown';
            this.props = Object.freeze({
                schema_version: 2,
                url: this.struct.url,
                screen_name: this.struct.screen_name
            });
        }
        return WebScreenShown;
    }());
    Events.WebScreenShown = WebScreenShown;
    var WebComponentShown = (function () {
        function WebComponentShown(struct) {
            this.struct = struct;
            this.name = 'Web Component Shown';
            this.props = Object.freeze({
                schema_version: 2,
                component_type: this.struct.component_type,
                component_name: this.struct.component_name,
                component_value: this.struct.component_value,
                url: this.struct.url,
                screen_name: this.struct.screen_name
            });
        }
        return WebComponentShown;
    }());
    Events.WebComponentShown = WebComponentShown;
    var WebInteractionTaken = (function () {
        function WebInteractionTaken(struct) {
            this.struct = struct;
            this.name = 'Web Interaction Taken';
            this.props = Object.freeze({
                schema_version: 2,
                url: this.struct.url,
                interaction_type: this.struct.interaction_type,
                component_type: this.struct.component_type,
                component_name: this.struct.component_name,
                component_value: this.struct.component_value,
                interaction_value: this.struct.interaction_value
            });
        }
        return WebInteractionTaken;
    }());
    Events.WebInteractionTaken = WebInteractionTaken;
    var WebAction = (function () {
        function WebAction(struct) {
            this.struct = struct;
            this.name = 'Web Action';
            this.props = Object.freeze({
                schema_version: 2,
                action_title: this.struct.action_title,
                action_value: this.struct.action_value,
                url: this.struct.url
            });
        }
        return WebAction;
    }());
    Events.WebAction = WebAction;
})(Events = exports.Events || (exports.Events = {}));
//# sourceMappingURL=web-event-schema.js.map